export default __webpack_public_path__ + "static/media/number_list_icon.f4e5cf35.svg";